/** Extract display text from a chat message row (structured model_message or legacy content). */
export function extractMessageContent(message) {
  if (!message || typeof message !== 'object') return '';

  const extractTextFromParts = (parts) => {
    if (!Array.isArray(parts)) return [];
    const texts = [];
    for (const part of parts) {
      if (!part || typeof part !== 'object') continue;
      if ((part.type === 'text' || part.type === 'output_text' || part.type === 'input_text') && typeof part.text === 'string') {
        texts.push(part.text);
      } else if (typeof part.content === 'string') {
        texts.push(part.content);
      } else if (typeof part.value === 'string') {
        texts.push(part.value);
      }
    }
    return texts;
  };

  const meta = message.metadata;
  if (meta && typeof meta === 'object') {
    const modelMessage = meta.model_message;
    if (Array.isArray(modelMessage) && modelMessage.length > 0) {
      const texts = [];
      for (const item of modelMessage) {
        if (!item || typeof item !== 'object') continue;
        if (typeof item.type === 'string') {
          texts.push(...extractTextFromParts([item]));
          continue;
        }
        if (Array.isArray(item.content)) {
          texts.push(...extractTextFromParts(item.content));
        } else if (typeof item.content === 'string') {
          texts.push(item.content);
        }
      }
      if (texts.length > 0) {
        return texts.join('\n');
      }
    }
  }
  return typeof message.content === 'string' ? message.content : '';
}
